// services/blackboxService.js
import api from "./api";

export const getAllBlackboxes = async (schemaName = null) => {
  try {
    const response = await api.get("/blackboxes/", {
      params: schemaName ? { client: schemaName } : {},
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching blackboxes:", error);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error(
        "Response data:",
        JSON.stringify(error.response.data, null, 2)
      );
      console.error(
        "Response headers:",
        JSON.stringify(error.response.headers, null, 2)
      );
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};

export const getBlackboxById = async (blackboxId, schemaName = null) => {
  try {
    const response = await api.get(`/blackboxes/${blackboxId}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching blackbox:", error);
    throw error;
  }
};

export const updateBlackbox = async (blackboxId, blackboxData, schemaName = null) => {
  try {
    const response = await api.put(`/blackboxes/${blackboxId}/`, blackboxData, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error updating blackbox:", error);
    throw error;
  }
};

export const createBlackbox = async (blackboxData, schemaName = null) => {
  try {
    const response = await api.post("/blackboxes/", blackboxData, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating blackbox:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
      console.error("Response headers:", error.response.headers);
    }
    throw error;
  }
};

export const deleteBlackbox = async (blackboxId, schemaName = null) => {
  try {
    const response = await api.delete(`/blackboxes/${blackboxId}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting blackbox:", error);
    throw error;
  }
};

// Optional: Add pagination support
export const getBlackboxesWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    const response = await api.get("/blackboxes/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching blackboxes with pagination:", error);
    throw error;
  }
};
